import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
import axios from "axios";
// import config from "../config";
// import moment from "moment";

Vue.use(Vuex);

let token = window.localStorage.getItem("token")
  ? window.localStorage.getItem("token")
  : "";
let refreshtoken = window.localStorage.getItem("refreshtoken")
  ? window.localStorage.getItem("refreshtoken")
  : "";
let defaultUser = {
  co_name: "",
  co_firstname: "",
  co_function: "",
  co_mobile1: "",
  co_tel1: "",
  co_email1: "",
  co_type: ""
};
let user = _.cloneDeep(defaultUser);
// try {
// 	user = JSON.parse(window.localStorage.getItem("user"));
// } catch (err) {
// 	console.error("err", err);
// }

export default new Vuex.Store({
  state: {
    myrights: {},
    rights: [
      { text: "Voir le module Contact", value: "see_contacts" },
      { text: "Créer/modifier des utilisateurs", value: "Create_contact" },
      { text: "Importer/modfier la Matrice", value: "import_matrice" },
      { text: "Voir le module Catalogue", value: "see_catalogues" },
      { text: "Créer/Modifier des catalogues", value: "create_catalogue" },
      // { text: "Modifier des catalogues", value: "edit_catalogue" },
      { text: "Exporter/imprimer des catalogues", value: "export_catalogue" }
      // { text: "Voir le module Préférences", value: "see_preferences" }
    ],
    norme_matrice: [
      { col: "A", val: "ref", remarque: "" },
      { col: "B", val: "Statut", remarque: "" },
      { col: "C", val: "Articles promo", remarque: "" },
      { col: "D", val: "Gencode", remarque: "" },
      {
        col: "E",
        val: "Désignation du produit",
        remarque: "Doit toujours être renseignée, texte en français"
      },
      { col: "F", val: "Gamme/Collection", remarque: "" },
      { col: "G", val: "Type PCB", remarque: "" },
      { col: "H", val: "Code marque", remarque: "" },
      { col: "I", val: "MMD/Référencement", remarque: "" },
      { col: "J", val: "Couleur", remarque: "" },
      { col: "K", val: "PCB", remarque: "" },
      { col: "L", val: "Type de pack", remarque: "" },
      { col: "M", val: "Famille", remarque: "" },
      { col: "N", val: "Sous-famille", remarque: "" },
      { col: "O", val: "Segment", remarque: "" },
      { col: "P", val: "Société", remarque: "" },
      { col: "Q", val: "Photo1", remarque: "Laisser vide" },
      { col: "R", val: "Photo2", remarque: "Laisser vide" },
      { col: "S", val: "Photo3", remarque: "Laisser vide" },
      { col: "T", val: "Gencode du carton", remarque: "" },
      { col: "U", val: "Délais", remarque: "" },
      {
        col: "V",
        val: "Recyclé",
        remarque: "Si la cellule a un texte ou un chiffre, l'icône apparait"
      },
      {
        col: "W",
        val: "Fabriqué en France",
        remarque: "Si la cellule a un texte ou un chiffre, l'icône apparait"
      },
      {
        col: "X",
        val: "Fabriqué en Europe",
        remarque: "Si la cellule a un texte ou un chiffre, l'icône apparait"
      },
      {
        col: "Y",
        val: "Recyclable",
        remarque: "Si la cellule a un texte ou un chiffre, l'icône apparait"
      },
      { col: "Z", val: "Laisser vide", remarque: "" },
      {
        col: "AA",
        val: "Fibre naturelles",
        remarque: "Si la cellule a un texte ou un chiffre, l'icône apparait"
      }
    ],
    items_catalog_languages: [
      { text: "Français", value: "fr" },
      { text: "Anglais", value: "en" },
      { text: "Espagnol", value: "sp" },
      { text: "Russe", value: "ru" }
    ],
    items_search_status: [
      { text: "A", value: "A" },
      { text: "M", value: "M" },
      { text: "N", value: "N" },
      { text: "AF", value: "AF" }
    ],
    items_search_promo: [
      { text: "oui", value: "promo" },
      { text: "non", value: "nopromo" }
    ],

    /////////immo///////////

    ficheAgent: false,
    // compteRenduToDo: [],
    // nbClientSuivi: 0,
    // nbBienSuivi: 0,
    // nbReportsToComplete: 0,
    reports_tocomplete: [],
    connected: false,
    token,
    refreshtoken,
    user,
    preferences: {
      personal: {},
      shared: {},
      rights: {}
    },

    items_languages: [],
    items_languages_all: [],
    items_countries: [],

    items_co_type: [],
    items_co_civilites: ["Mme", "Mlle", "M"],

    items_page_right: [],

    items_fi_subtype: [
      { value: "image", text: "Image" },
      { value: "plan", text: "Plan" }
    ],
    items_co_lab3: [
      { value: 0, text: "En cours" },
      { value: 1, text: "Validé" },
      { value: 2, text: "*DS*" }
    ]
  },
  mutations: {
    // utiliser simplement pour mettre à jour les infos essentielles
    set_user_simple(state, user) {
      // console.log("user", user);
      state.user.co_name = user.co_name;
      state.user.co_firstname = user.co_firstname;
      state.user.co_type = user.co_type;
      state.user.updatedAt = user.updatedAt;
      state.myrights = user.co_right;
    },
    set_connexion(state, what) {
      if (!what.token) {
        axios.defaults.headers.common["x-auth-apikey"] = "";
        window.localStorage.removeItem("token");
        state.token = null;
        window.localStorage.removeItem("refreshtoken");
        state.refreshtoken = null;
        window.localStorage.removeItem("user");
        state.user = _.cloneDeep(defaultUser);
        state.myrights = {};
        state.connected = false;

        return;
      }
      // console.log("token, refreshtoken, user", what.token, what.refreshtoken, what.user);
      axios.defaults.headers.common["x-auth-apikey"] = what.token;
      window.localStorage.setItem("token", what.token);
      state.token = what.token;
      window.localStorage.setItem("refreshtoken", what.refreshtoken);
      state.refreshtoken = what.refreshtoken;
      window.localStorage.setItem("user", JSON.stringify(what.user));
      state.user = _.cloneDeep(what.user);
      state.myrights = _.cloneDeep(what.user.co_right);
      // console.log("state.myrights", state.myrights);
      // console.log("what.preferences", what);
      _.each(what.preferences.items, (val, key) => {
        state[key] = what.preferences.items[key];
      });

      state.connected = true;
      //this.dispatch("load_nbclientsuivi");
    },
    set_preferences(state, data) {
      state.preferences[data.preference] = data.data;
    }
  },
  actions: {},
  getters: {
    // get_rights(state) {
    //   if (!state.user || !state.user.co_right) return {};
    //   return state.user.co_right;
    // },
    get_user(state) {
      return state.user;
    }
  }
});
